var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSmallRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "arrow_small_right",
    d: "M7.701 2.299a.993.993 0 00-1.413 0 1.06 1.06 0 000 1.454l3.876 4-3.876 4a1.06 1.06 0 000 1.454.993.993 0 001.413 0l4.574-4.724a1.052 1.052 0 000-1.462z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6228",
    fill: "none",
    d: "M0 0h16v16H0z"
  })));
}
export default SvgArrowSmallRight;